export const PATTERNS = {
    STAIRCASE_RIGHT: {
        name: "Staircase Right",
        steps: [
            { dx: 80, dy: 80 },
            { dx: 80, dy: 80 },
            { dx: 80, dy: 80 }
        ]
    },
    STAIRCASE_LEFT: {
        name: "Staircase Left",
        steps: [
            { dx: -80, dy: 80 },
            { dx: -80, dy: 80 },
            { dx: -80, dy: 80 }
        ]
    },
    ZIGZAG: {
        name: "ZigZag",
        steps: [
            { dx: 150, dy: 120 },
            { dx: -150, dy: 120 },
            { dx: 150, dy: 120 }
        ]
    },
    TUNNEL: {
        name: "Tunnel",
        steps: [
            { dx: 0, dy: 150, type: "walls" } // Special handling for walls
        ]
    },
    SPLIT: {
        name: "Split",
        steps: [
            { dx: -100, dy: 100, branch: true },
            { dx: 100, dy: 100 }
        ]
    },
    DIAMOND: {
        name: "Diamond",
        steps: [
            { dx: -80, dy: 80 },
            { dx: 160, dy: 0 }, // Side by side
            { dx: -80, dy: 80 } // Merge back
        ]
    },
    SPIRAL: {
        name: "Spiral",
        steps: [
            { dx: 100, dy: 100 },
            { dx: 0, dy: 100 },
            { dx: -100, dy: 100 },
            { dx: -100, dy: 0 },
            { dx: 0, dy: 100 }
        ]
    },
    BRIDGE: {
        name: "Bridge",
        steps: [
            { dx: -120, dy: 100 },
            { dx: 0, dy: 0, width: 240 }, // Wide platform
            { dx: 120, dy: 100 }
        ]
    },
    PYRAMID: {
        name: "Pyramid",
        steps: [
            { dx: 0, dy: 100, width: 60 },
            { dx: 0, dy: 80, width: 120 },
            { dx: 0, dy: 80, width: 180 },
            { dx: 0, dy: 80, width: 120 },
            { dx: 0, dy: 100, width: 60 }
        ]
    },
    LADDER: {
        name: "Ladder",
        steps: [
            { dx: 0, dy: 100, width: 80 },
            { dx: 0, dy: 100, width: 80 },
            { dx: 0, dy: 100, width: 80 },
            { dx: 0, dy: 100, width: 80 }
        ]
    },
    WAVE: {
        name: "Wave",
        steps: [
            { dx: 100, dy: 80 },
            { dx: -100, dy: 80 },
            { dx: 100, dy: 80 },
            { dx: -100, dy: 80 },
            { dx: 100, dy: 80 }
        ]
    },
    CASTLE: {
        name: "Castle",
        steps: [
            { dx: -60, dy: 100, width: 80 },
            { dx: 120, dy: 0, width: 80 },
            { dx: -60, dy: 100, width: 80 },
            { dx: 0, dy: 80, width: 200 }
        ]
    },
    ARROW: {
        name: "Arrow",
        steps: [
            { dx: -80, dy: 100, width: 60 },
            { dx: 160, dy: 0, width: 60 },
            { dx: -80, dy: 100, width: 120 }
        ]
    }
};

